import { render, staticRenderFns } from "./ThreeModel.vue?vue&type=template&id=51989c93&scoped=true"
import script from "./ThreeModel.vue?vue&type=script&lang=js"
export * from "./ThreeModel.vue?vue&type=script&lang=js"
import style0 from "./ThreeModel.vue?vue&type=style&index=0&id=51989c93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51989c93",
  null
  
)

export default component.exports